import { useQuery } from "@apollo/client/react";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../components/dataGrid/DataGridGenerico";
import { useInsumosSearchDialogColumns } from "../hooks/useInsumosSearchDialogColumns";
import { GET_ENVIO_INSUMOS_DISPONIBLES } from "../../../data/graphQL/queries/GestionAsistencial/getEnvioInsumosDisponibles";
import { TextInput } from "../../../components/textInput/TextInput";

export function InsumosSearchDialog({
  open,
  handleCloseDialog,
  idEvaluacion,
  insumosRows,
  setInsumosRows,
  setIsActualizarStockRequired
}) {
  const [textFilter, setTextFilter] = useState("");
  const columns = useInsumosSearchDialogColumns();

  const { data, loading } = useQuery(GET_ENVIO_INSUMOS_DISPONIBLES, {
    variables: {
      idEvaluacion
    }
  });

  const filteredRows =
  data?.envioInsumosDisponibles?.
  filter((row) =>
    row.descripcion.toLowerCase().includes(textFilter.toLowerCase()) ||
    row.idInsumo.toLowerCase().includes(textFilter.toLowerCase())
  ).
  filter(
    (row) => !insumosRows.some((insumo) => insumo.idInsumo === row.idInsumo)
  ) || [];

  const handleRowClick = (param) => {
    const excludeKeys = [
    "__typename",
    "id",
    "eleccion",
    "tipoInsumo",
    "unidad"];


    const filteredRow = Object.fromEntries(
      Object.entries(param.row).filter(([key]) => !excludeKeys.includes(key))
    );

    const newRow = {
      ...filteredRow,
      por: "A",
      cantidadPlan: "0",
      cantidadDiaria: "0",
      cantidadAPedir: "0",
      saldo: "-",
      cod_Articulo: "-",
      stockDisponibleDeposito: "-",
      cantidadCuota: "-",
      cuotaActiva: "-",
      indFutura: false
    };

    setInsumosRows((prevRows) => [...prevRows, newRow]);
    setIsActualizarStockRequired(true);
    handleCloseDialog();
  };

  return (
    <CustomDialog
      title="Buscador de insumos"
      open={open}
      fullWidth
      maxWidth="md"
      onCancel={handleCloseDialog}
      cancelText="Cerrar"
      acceptText="Guardar">
      
      <Box display="flex" flexDirection="column" gap="20px">
        <Typography component="p" fontSize="14px">
          Haz click sobre un cliente para agregarlo y seguir con el formulario.
        </Typography>
        <Box sx={{ width: { lg: "250px", md: 1 } }}>
          <TextInput
            placeholder="Filtrar"
            value={textFilter}
            searchIcon
            onChange={(e) => setTextFilter(e.target.value)}
            onClearButtonClick={() => setTextFilter("")} />
          
        </Box>
        <DataGridGenerico
          columns={columns}
          rows={filteredRows}
          loading={loading}
          onRowClick={handleRowClick}
          toolbar={false} />
        
      </Box>
    </CustomDialog>);

}